import React, { useState, useEffect } from 'react';
import Loader from 'react-loaders';
import './index.scss';
import AnimatedLetters from '../AnimatedLetters/index';
import webAppsData from '../../data/webApps.json';
import Popup from 'reactjs-popup';

const WebApps = () => {
  const [letterClass, setLetterClass] = useState('text-animate');
  const [showPopup, setShowPopup] = useState(false);
  const [redirect, setRedirect] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)

    return () => {
      clearTimeout(timer)
    }
  })

  const handleButtonClick = (url, showWarn) => {
    if (showWarn === 'true') {
        setShowPopup(true);
        setRedirect(url);
    } else {
        window.open(url);
    }
  }

  const handlePopupClose = () => {
    setShowPopup(false);
    window.open(redirect);
  }

  const renderWebApps = (webApps) => {
    return (
      <div className="images-container web-apps-container">
        {webApps.map((port, idx) => {
          return (
            <div className="image-box" key={idx}>
              <img
                className="portfolio-image web-app-image"
                src={port.cover}
                alt={port.alt}
              />
              <div className="content">
                <h4 className="title">{port.title}</h4>
                <p className="description">{port.description}</p>
                <button
                  className="button"
                  onClick={() => handleButtonClick(port.url, port.showWarn)}
                >
                  View
                </button>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  const PopupModal = () => {
    return (
      <Popup
        open={showPopup}
        closeOnDocumentClick
        onClose={handlePopupClose}
        position="top center"
        contentStyle={{ background: 'transparent' }}
        modal
        nested
      >
        <div className="modal popup-content">
          <button className="close" onClick={handlePopupClose}>
            &times;
          </button>

          <h2>
          Please note that the website you are about to access is currently experiencing slow loading times.  I am actively working to improve the performance. 
          </h2>
          <h2>
          Sorry for an inconvenience.
          </h2>
        </div>
      </Popup>
    )
  }

  return (
    <>
      <div className="container portfolio-page">
        <h1 className="page-title">
          <AnimatedLetters
            letterClass={letterClass}
            strArray={'Web Apps'.split('')}
            idx={15}
          />
        </h1>
        <div>{renderWebApps(webAppsData.webApps)}</div>
      </div>
      <div>
        <PopupModal />
      </div>
      <Loader type="ball-clip-rotate-multiple" />
    </>
  )
}

export default WebApps
